/**
 * Pre-compiled localized messages for RichTextInput component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import richTextInputMessages_en from "./intl/en";
import richTextInputMessages_de from "./intl/de";
import richTextInputMessages_es from "./intl/es";
import richTextInputMessages_fr from "./intl/fr-FR";
import richTextInputMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const richTextInputMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(richTextInputMessages_en),
  de: normalizeMessages(richTextInputMessages_de),
  es: normalizeMessages(richTextInputMessages_es),
  "fr-FR": normalizeMessages(richTextInputMessages_fr),
  "pt-BR": normalizeMessages(richTextInputMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for RichTextInput component
 */
export type RichTextInputMessageKey =
  | "bold"
  | "bulletedList"
  | "code"
  | "headingFive"
  | "headingFour"
  | "headingOne"
  | "headingThree"
  | "headingTwo"
  | "italic"
  | "listFormatting"
  | "moreFormattingOptions"
  | "moreStyles"
  | "numberedList"
  | "paragraph"
  | "quote"
  | "redo"
  | "strikethrough"
  | "subscript"
  | "superscript"
  | "textFormatting"
  | "textStyle"
  | "textStyleMenu"
  | "underline"
  | "undo";
